import { Api } from 'models/services/api';
import { DeleteCompanyQuery } from 'models/services/graphql';

import { CompanyData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeleteCompany($id: ID!) {
    ${DeleteCompanyQuery}
  }
`;

type ResponseData = {
  data: {
    deleteCompany: CompanyData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: CompanyData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.deleteCompany;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };